import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function sendEnrollmentAccountingPhoneReminder(ids: number[]) {
  return restApiClient
    .url(constructApiUrl(API['enrollment-accountings'].sendPhoneReminder.url, null))
    .post({ ids })
}
